<button
  type="button"
  [class]="buttonClass"
  [disabled]="isDisabled"
  (click)="onClick()"
>
  <i class="fas fa-eye"></i>
  {{ "Verify" | localize }}<ng-container *ngIf="isDisabled"> ({{ remainingSeconds }}s)</ng-container>
</button>
